import React, { useState, useCallback } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import './css/App.css'
import Sidebar from './Sidebar';
import Footer from './Footer';
import WebhooksReference from './components/WebhooksReference';
import APIReference from './components/APIReference';
import ZapierReference from './components/ZapierReference';
import Changelog from './components/Changelog';
import MCPServer from './components/MCPServer';

const App = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = useCallback(() => setSidebarOpen(o => !o), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <BrowserRouter>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <div className={`app-shell${sidebarOpen ? ' sidebar-open' : ''}`}>
        <button
          type="button"
          className="sidebar-toggle"
          aria-label={sidebarOpen ? 'Close navigation' : 'Open navigation'}
          aria-expanded={sidebarOpen}
          aria-controls="primary-nav"
          onClick={toggleSidebar}
        >
          <span aria-hidden="true">{sidebarOpen ? '✕' : '☰'}</span>
        </button>
        <div className="sidebar-backdrop" onClick={closeSidebar} aria-hidden="true" />
        <Sidebar onNavigate={closeSidebar} />
        <main id="main-content" className="app-main">
          <Switch>
            <Redirect exact from="/" to="/api" />
            <Route path="/api" component={APIReference} />
            <Route path="/webhooks" component={WebhooksReference} />
            <Route path="/zapier" component={ZapierReference} />
            <Route path="/changelog" component={Changelog} />
            <Route path="/mcp" component={MCPServer} />
          </Switch>
          <Footer />
        </main>
      </div>
    </BrowserRouter>
  );
};

export default App;
